import {
    dehydrate,
    hydrate,
    QueryClient,
    VueQueryPlugin,
    type DehydratedState,
} from '@tanstack/vue-query';
import type {Plugin} from 'vue';

export const tanStackPlugin = {
    install(app) {
        const queryClient = new QueryClient({
            defaultOptions: {
                queries: {
                    // 10 minutes - can be overriden for each individual query
                    staleTime: 10 * 60 * 1000,
                },
            },
        });

        addQueryPersistence(queryClient);

        app.use(VueQueryPlugin, {queryClient});
    },
} satisfies Plugin;

function addQueryPersistence(queryClient: QueryClient) {
    try {
        const cachedData = localStorage.getItem('vue-query-cache');

        if (cachedData) {
            hydrate(queryClient, JSON.parse(cachedData));
        }
    } catch {
        // ignore errors
    }

    queryClient.getQueryCache().subscribe(event => {
        if (!shouldPersistQuery(event.query)) {
            return;
        }
        const data = dehydrate(queryClient);
        const filteredData = {
            queries: data.queries.filter(shouldPersistQuery),
            mutations: data.mutations.filter(shouldPersistQuery),
        } satisfies DehydratedState;
        localStorage.setItem('vue-query-cache', JSON.stringify(filteredData));
    });
}

function shouldPersistQuery(query: {meta?: Record<string, unknown>}): boolean {
    return !!query.meta?.persist;
}
